import React, { useState, useEffect, useContext, useRef } from "react";
import { Spin } from "antdv5";
import { PrinterOutlined } from "@ant-design/icons";
import DefaultLayout from "components/layout/DefaultLayout";
import Container from "components/common/Container";
import useAPI from "components/customHook/useApi";
import ClubOpts from "components/common/ClubOpts";
import { color } from "styles/color";
import { Section, TableOutter } from "../styles/DeviceConnet";
import DeviceConnectTable from "components/pages/DeviceConnect/DeviceConnectTable";
import StyledTable from "components/pages/DeviceConnect/StyledTable";
import SecondStyledTable from "components/pages/DeviceConnect/SecondStyledTable";
import { IDevice, IDeviceConnection } from "../api_types";
import { context } from "components/context/Context";
import {
  GETJsonDeviceActionIDList,
  GETJsonDeviceActionIDTime,
  GETJsonDeviceConnectInfoList,
  GETJsonDeviceList,
} from "../api";

const linkTime = (record: string) => {
  const nowDate = Date.now();
  const finalTime = Date.parse(record);
  if (nowDate - finalTime > 300000) {
    return true;
  } else if (nowDate - finalTime < 300000) {
    return false;
  }
};

const DeviceConnect = () => {
  const { state } = useContext(context);
  const {
    preventRefreshCount,
    loading: spinLoading,
    handleAuth,
    clubList,
  } = useAPI();
  const [linkDevice, setLinkDevice] = useState<IDeviceConnection[]>([]);
  const [unlink, setUnlink] = useState<IDeviceConnection[]>([]);
  const [unNormal, setUnNormal] = useState<IDeviceConnection[]>([]);
  const [startTime, setStartTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [countDown, setCountDown] = useState(59);
  const [nowRecord, setNowRecord] = useState(null);
  const fetchDevice = async () => {
    setLoading(true);
    setShow(false);
    if (localStorage.getItem("gid") !== "") {
      const gid = localStorage.getItem("gid") || "";
      const token = localStorage.getItem("token") || "";
      const parsedData = await GETJsonDeviceList(gid, token);
      if (parsedData.Data) {
        let deviceID: string[] = [];
        parsedData.Data.forEach((element: IDevice) =>
          deviceID.push(element.DeviceUUID)
        );
        const gid = localStorage.getItem("gid") || "";
        const token = localStorage.getItem("token") || "";
        const parsedLinkData = await GETJsonDeviceConnectInfoList(gid, token);
        const validData = await parsedLinkData.Data.filter(
          (data: IDeviceConnection) => deviceID.includes(data.DeviceUUID)
        );
        let validResult: (IDeviceConnection & { rank: number })[] = [];
        validData.forEach((elem: IDeviceConnection, i: number) =>
          validResult.push({ ...elem, rank: i + 1 })
        );
        setLinkDevice(validResult);
        const unValidData = await parsedLinkData.Data.filter(
          (data: IDeviceConnection) => !deviceID.includes(data.DeviceUUID)
        );
        let unValidResult: (IDeviceConnection & { rank: number })[] = [];
        await unValidData.forEach((elem: IDeviceConnection, i: number) =>
          unValidResult.push({ ...elem, rank: i + 1 })
        );
        setUnNormal(unValidResult);
        if (unValidResult.length > 0) {
          setShow(true);
        }
        let linkedDeviceID: string[] = [];
        await parsedLinkData.Data.forEach((elem: IDeviceConnection) =>
          linkedDeviceID.push(elem.DeviceUUID)
        );
        const unLinkData = await parsedData.Data.filter(
          (data: IDevice) => !linkedDeviceID.includes(data.DeviceUUID)
        );
        let unLinkResult: (IDeviceConnection & { rank: number })[] = [];
        await unLinkData.forEach((elem: IDeviceConnection, i: number) =>
          unLinkResult.push({ ...elem, rank: i + 1 })
        );
        setUnlink(unLinkResult);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
      alert("查无资料");
    }
  };
  const fetchNowRecord = async () => {
    const gid = localStorage.getItem("gid") || "";
    const token = localStorage.getItem("token") || "";
    const parsedData = await GETJsonDeviceActionIDList(gid, token);
    setNowRecord(parsedData.Data?.[0]?.ActionID);
  };
  const fetchStartTime = () => {
    if (localStorage.getItem("onAuth") === "true") {
      const gid = localStorage.getItem("gid") || "";
      const token = localStorage.getItem("token") || "";
      GETJsonDeviceActionIDTime(gid, token).then((res) => {
        if (res.Data && res.Data.length !== 0) {
          setStartTime(res.Data.Time);
        }
      });
    }
  };
  useEffect(() => {
    const count = setTimeout(() => {
      setCountDown(countDown - 1);
      if (countDown === 0) {
        setCountDown(59);
        fetchDevice();
        handleAuth();
      } else {
        setLoading(false);
      }
    }, 1000);

    return () => {
      clearTimeout(count);
    };
  }, [countDown]);
  useEffect(() => {
    setCountDown(59);
    handleAuth();
    fetchStartTime();
    setShow(false);

    if (localStorage.getItem("onAuth") === "true") {
      preventRefreshCount(fetchDevice, 3);
      preventRefreshCount(fetchNowRecord, 3);
    }
  }, [state?.gid]);
  return (
    <DefaultLayout>
      <Spin
        spinning={spinLoading}
        tip={"请等候3秒"}
        style={{ overflow: "hidden" }}
      >
        <Container>
          <Section>
            <div
              className="btn"
              onClick={() => window.print()}
              style={{ whiteSpace: "nowrap" }}
            >
              <PrinterOutlined /> 打印本页
            </div>
            <ClubOpts clubList={clubList} />
          </Section>
          <Section>
            <div className="text">当前记录编号：{nowRecord}</div>
            <div className="text">建立时间：{startTime}</div>
            <div className="text" style={{ color: `${color.warnning}` }}>
              {countDown} 秒后自动刷新
            </div>
          </Section>
          <TableOutter>
            <DeviceConnectTable
              linkDevice={linkDevice}
              loading={loading}
              linkTime={linkTime}
              nowRecord={nowRecord}
            />
            <StyledTable unlink={unlink} loading={loading} />
            {show ? (
              <SecondStyledTable unNormal={unNormal} loading={loading} />
            ) : null}
          </TableOutter>
        </Container>
      </Spin>
    </DefaultLayout>
  );
};

export default DeviceConnect;
